import { SCENE_INTERACTION } from "../../constants/scene";
import { MeetingChatControls, MeetingContainer, MeetingMediaContainer } from "./MeetingMode/MeetingModeView";
import { SCENE_EVENTS } from "../MVC/EVENTS/ModelEvents";
import { ANT_MEDIA_SERVER_BAGELSS_EVENTS } from "../WebRTC/constants";
import { SOCKET_EVENTS } from "../../socket/Events";
import { GLOBAL_EVENTS } from "../../constants/global";

export default class MeetingModeController {
  constructor({ model, socket }) {
    this.model = model;
    this.socket = socket;

    window.mmeetingModeController = this;

    this.meetingModeContainer = new MeetingContainer({ controller: this, model });

    this.callChatControls = $(MeetingChatControls.template());
    MeetingChatControls.attach(this.callChatControls)
    MeetingChatControls.init({ controller: this, model })

    this.medias = [];

    window.gridModeController = this;

    const update = () => {
      this.fetchVideoContainers();
    }

    window.activateOwnVideoInsideGrid = () => {
      // requestAnimationFrame(update);
    }

    this.model.addEventListener("TEST_RE_CREATE_WEB_STREAMS", () => requestAnimationFrame(update));
    this.model.addEventListener(SCENE_INTERACTION.SET_OCCUPIED_SEATS, () => requestAnimationFrame(update));
    this.model.addEventListener(SCENE_INTERACTION.SET_OCCUPIED_SCREEN_SHARE_SEATS, () => requestAnimationFrame(update));
    this.model.addEventListener(ANT_MEDIA_SERVER_BAGELSS_EVENTS.TEST_FOR, () => requestAnimationFrame(update));
    this.model.addEventListener(SCENE_INTERACTION.SOCKET_USER_INFO_CHANGED, (e) => {
      const { data } = e;
      if (data.currentSceneId !== this.model.config.currentSceneId) {
        return
      }

      requestAnimationFrame(update)
    });

    this.model.addEventListener("REMOVE_STREAM", (e) => {
      this.removeRemoteVideoContainer(e.data?.id)
    });

    this.model.addEventListener(ANT_MEDIA_SERVER_BAGELSS_EVENTS.PLAY_FINISHED, () => {
      setTimeout(() => {
        this.fetchVideoContainers();
      }, 1000);
      if (!this.model.socket.isAnybodyStreaming()) {
        this.model.dispatchEvent({ type: SCENE_EVENTS.SHOW_SCREEN_SHARE_BUTTON_IN_OWN_USER_MENU })
      } else {
        this.model.dispatchEvent({ type: SCENE_EVENTS.HIDE_SCREEN_SHARE_BUTTON_IN_OWN_USER_MENU })
      }
    });
    this.model.addEventListener(ANT_MEDIA_SERVER_BAGELSS_EVENTS.PLAY_STARTED, () => {
      setTimeout(() => {
        this.fetchVideoContainers();
      }, 1000);
      if (!this.model.socket.isAnybodyStreaming()) {
        this.model.dispatchEvent({ type: SCENE_EVENTS.SHOW_SCREEN_SHARE_BUTTON_IN_OWN_USER_MENU })
      } else {
        this.model.dispatchEvent({ type: SCENE_EVENTS.HIDE_SCREEN_SHARE_BUTTON_IN_OWN_USER_MENU })
      }
    });
    this.model.socket.addEventListener(SOCKET_EVENTS.USER_CHANGED_SCREEN_SHARE_SEAT, () => {
      this.fetchVideoContainers();
    })

    this.model.addEventListener(SCENE_EVENTS.GRID_MODE, (e) => {
      const { data } = e;

      if (data.showGrid) {
        this.meetingModeContainer.show()
        requestAnimationFrame(update)
        window.baglessTrack && window.baglessTrack(this.model.config, "User opened meeting mode")
        // MeetingChatControls.show()
      } else {
        this.medias.forEach((media) => {
          media.leftMediaContainer?.remove();
          media.rightMediaContainer?.remove();
          window.baglessTrack && window.baglessTrack(this.model.config, "User closed meeting mode")
        })
        this.medias = [];
        this.meetingModeContainer.clear()
        this.meetingModeContainer.hide()
        if (window.baglessTrack) {
        }
        // MeetingChatControls.hide()
      }
    })

    this.model.addEventListener(SOCKET_EVENTS.USER_MICROPHONE_STATE_CHANGED, () => {
      let allUsers = this.socket.getUsersWhoStream();
      const me = this.socket.getUsersObject()[this.model.config.userId];
      const sceneId = me.currentSceneId;
      allUsers = allUsers.filter(user => user.currentSceneId === sceneId);

      allUsers.forEach((user) => {
        const media = this.medias.find(m => m.user.userId === user.userId && m.user.userId !== this.model.config.userId);
        if (media) {
          media.leftMediaContainer?.updateMediaUI({
            userAudioMuted: user.userAudioMuted || user.userMicOn === false || user.userWantsAudio === false
          });
          media.rightMediaContainer?.updateMediaUI({
            userAudioMuted: user.userAudioMuted || user.userMicOn === false || user.userWantsAudio === false
          });
        }
      })
    })

    this.model.addEventListener(SOCKET_EVENTS.USER_VIDEO_STATE_CHANGED, () => {
      const sceneId = this.model.socket.getUsersObject()[this.model.config.userId].currentSceneId;
      let allUsers = this.socket.getUsersWhoStream()
      allUsers = allUsers.filter(user => user.currentSceneId === sceneId);

      allUsers.forEach((user) => {
        const media = this.medias.find(m => m.user.userId === user.userId && m.user.userId !== this.model.config.userId);
        if (media) {
          media.leftMediaContainer?.updateMediaUI({
            userVideoMuted: user.userVideoMuted || user.userVideoOn === false || user.userWantsCamera === false
          });
          media.rightMediaContainer?.updateMediaUI({
            userVideoMuted: user.userVideoMuted || user.userVideoOn === false || user.userWantsCamera === false
          })
        }
      })
    })

    this.model.addEventListener(SCENE_EVENTS.USER_SEAT_TURN_MIC_ON, (e) => {
      const media = this.medias.find(m => m.user.userId === this.model.config.userId);
      if (media) {
        media.leftMediaContainer?.updateMediaUI({ userAudioMuted: false });
      }
    });
    this.model.addEventListener(SCENE_EVENTS.USER_SEAT_TURN_MIC_OFF, (e) => {
      const media = this.medias.find(m => m.user.userId === this.model.config.userId);
      if (media) {
        media.leftMediaContainer?.updateMediaUI({ userAudioMuted: true });
      }
    })

    this.model.addEventListener(SCENE_EVENTS.USER_SEAT_TURN_CAMERA_ON, (e) => {
      const media = this.medias.find(m => m.user.userId === this.model.config.userId);
      if (media) {
        media.leftMediaContainer?.updateMediaUI({ userVideoMuted: false });
      }
    })
    this.model.addEventListener(SCENE_EVENTS.USER_SEAT_TURN_CAMERA_OFF, (e) => {
      const media = this.medias.find(m => m.user.userId === this.model.config.userId);
      if (media) {
        media.leftMediaContainer?.updateMediaUI({ userVideoMuted: true });
      }
    })

    this.model.addEventListener(SOCKET_EVENTS.DISCONNECT, () => {
      if (this.model.streamController.isInRoom()) {
        const callback = () => {
          const meetingModeButton = $(".world-bottom-nav__area__item.own_chair__controls__toggle-meeting-mode")
          if (meetingModeButton.length) {
            if (meetingModeButton.hasClass('selected')) {
              meetingModeButton.trigger('click');
              setTimeout(() => {
                meetingModeButton.trigger('click');
              }, 50);
            }
          }
          this.model.removeEventListener(ANT_MEDIA_SERVER_BAGELSS_EVENTS.CAMERA_ROOM_JOINED, callback)
        }
        this.model.addEventListener(ANT_MEDIA_SERVER_BAGELSS_EVENTS.CAMERA_ROOM_JOINED, callback)
      }

      try {
        this.model.view._stopScreenShare();
      } catch (e) {
        console.error(e);
      }
    });

    this.model.addEventListener(GLOBAL_EVENTS.MOOD_CHANGED, (e) => {
      const { senderId, data } = e.data;

      const media = this.medias.find(m => String(m.user.userId) === String(senderId));
      if (media) {
        media.leftMediaContainer?.updateMediaUI({ userVideoMuted: false });
        media.leftMediaContainer?.setUserMood(data.newMood);
        media.rightMediaContainer?.setUserMood(data.newMood);
      }
    });
  }

  fetchVideoContainers() {
    if (!this.meetingModeContainer.isShown()) {
      return
    }
    // Get list of users who are streaming
    const sceneId = this.model.socket.getUsersObject()[this.model.config.userId].currentSceneId;
    let allUsers = this.socket.getUsersWhoStream()
    allUsers = allUsers.filter(user => user.currentSceneId === sceneId);

    // Unique users
    const uniqueUsersMap = new Map();
    allUsers.forEach(user => {
      if (!uniqueUsersMap.has(user.userId)) {
        uniqueUsersMap.set(user.userId, user);
      }
    });
    const allUsersWhoStream = Array.from(uniqueUsersMap.values());

    // remove streams that are not in allUsersWhoStream
    const streamsToRemove = this.medias.filter(m => !allUsersWhoStream.find(u => u.userId === m.user.userId));
    streamsToRemove.forEach(m => {
      this.removeVideoContainerByUserId(m.user.userId);
    });

    allUsersWhoStream.forEach((socketUser) => {
      const cameraStreamId = socketUser.webcamStreamId;
      const screenStreamId = socketUser.screenShareStreamId;
      const media = this.medias.find(m => m.user.userId === socketUser.userId);

      if (!cameraStreamId && !screenStreamId) {
        if (media) {
          this.removeVideoContainerByUserId(socketUser.userId);
        }
        return;
      }

      const isOwnStream = socketUser.userId === this.model.config.userId;
      const isDoubleStream = !!(cameraStreamId && screenStreamId);

      if (isOwnStream) {
        if (cameraStreamId) {
          this.updateRemoteVideoContainer({
            socketUser,
            videoSource: document.querySelector(`#myVideo2`),
            isDoubleStream,
            isLeft: true
          });
        }
        if (screenStreamId) {
          this.updateRemoteVideoContainer({
            socketUser,
            videoSource: document.querySelector(`#screenVideoANT`),
            isDoubleStream,
            isLeft: false
          });
        }
      } else {
        if (cameraStreamId) {
          this.updateRemoteVideoContainer({
            socketUser,
            videoSource: document.querySelector(`#remoteVideo-${cameraStreamId}`),
            isDoubleStream,
            isLeft: true
          });
        }
        if (screenStreamId) {
          this.updateRemoteVideoContainer({
            socketUser,
            videoSource: document.querySelector(`#remoteVideo-${screenStreamId}`),
            isDoubleStream,
            isLeft: false
          });
        }
      }
    })
  }

  updateRemoteVideoContainer({ socketUser, videoSource = null, isDoubleStream = false, isLeft = true }) {
    const {
      userId,
      webcamStreamId,
      userAvatarUrl,
      userName,
      screenShareOccupiedSeats,
      userAudioMuted,
      userVideoMuted,
      userMicOn,
      userVideoOn,
      userWantsAudio,
      userWantsCamera,
    } = socketUser;

    let media = this.medias.find(m => m.user.userId === userId);
    let mediaContainer = null;
    if (media) {
      const previousDoubleStream = media.leftMediaContainer && media.rightMediaContainer;
      const shouldRemoveRightStream = !isDoubleStream && previousDoubleStream;
      if (shouldRemoveRightStream) {
        this.meetingModeContainer.removeMedia(media.rightMediaContainer);
        media.rightMediaContainer = null;
      } else {
        if (isDoubleStream) {
          if (isLeft) {
            mediaContainer = media.leftMediaContainer;
          } else {
            mediaContainer = media.rightMediaContainer;
          }
        } else {
          mediaContainer = media.leftMediaContainer;
        }
      }

      if (mediaContainer) {
        mediaContainer.updateMediaUI({
          userAudioMuted: userAudioMuted || userMicOn === false || userWantsAudio === false,
          userVideoMuted: userVideoMuted || userVideoOn === false || userWantsCamera === false
        })
        if (videoSource?.srcObject) {
          mediaContainer.setVideoStream(videoSource.srcObject, {
            onVideoReady: (videoElement) => {
              mediaContainer.setMicTestHandler(videoElement.srcObject)
            }
          })
        }
        return;
      }
    }

    mediaContainer = new MeetingMediaContainer({ model: this.model, socketUser })
    mediaContainer.updateUserInfo({ userId, name: userName, avatarUrl: userAvatarUrl })
    mediaContainer.setUserMood(socketUser.currentUserMood)
    mediaContainer.updateMediaUI({ userAudioMuted, userVideoMuted })
    mediaContainer.updateMediaUI({
      userAudioMuted: userAudioMuted || userMicOn === false || userWantsAudio === false,
      userVideoMuted: userVideoMuted || userVideoOn === false || userWantsCamera === false
    })

    if (videoSource?.srcObject) {
      mediaContainer.setVideoStream(videoSource.srcObject, {
        onVideoReady: (videoElement) => {
          mediaContainer.setMicTestHandler(videoElement.srcObject)
        }
      })
    }

    mediaContainer.$template.attr('id', `remoteScreenShareVideo_${userId}`)
    mediaContainer.$elements.video.attr('id', `screenShareVideo_${userId}`)

    if (!media) {
      media = {
        user: socketUser,
        leftMediaContainer: null,
        rightMediaContainer: null,
      }

      this.medias.push(media);
    }

    if (isDoubleStream) {
      if (isLeft) {
        media.leftMediaContainer = mediaContainer;
      } else {
        media.rightMediaContainer = mediaContainer;
      }
    } else {
      media.leftMediaContainer = mediaContainer;
    }

    if (media.leftMediaContainer) {
      this.meetingModeContainer.addMedia(media.leftMediaContainer);
    }
    if (media.rightMediaContainer) {
      this.meetingModeContainer.addMedia(media.rightMediaContainer);
    }

    this.syncVideoContainers()
  }

  removeVideoContainerByUserId(userId) {
    if (!userId) {
      return;
    }
    const media = this.medias.find(m => m.user.userId === userId);
    if (media) {
      if (media.leftMediaContainer) {
        this.meetingModeContainer.removeMedia(media.leftMediaContainer);
        media.leftMediaContainer.remove();
      }
      if (media.rightMediaContainer) {
        this.meetingModeContainer.removeMedia(media.rightMediaContainer);
        media.rightMediaContainer.remove();
      }
      this.medias.splice(this.medias.indexOf(media), 1);
    }

    this.syncVideoContainers()
  }

  removeRemoteVideoContainer(streamId) {
    if (!streamId) {
      return;
    }

    let isLeft = false;
    const media = this.medias.find(m => {
      const isLeftMedia = m.leftMediaContainer?.streamId === streamId
      const isRightMedia = m.rightMediaContainer?.streamId === streamId
      if (isLeftMedia) {
        isLeft = true;
      }
      return isLeftMedia || isRightMedia
    });

    if (media) {
      if (isLeft) {
        media.leftMediaContainer = null;
      } else {
        media.rightMediaContainer = null;
      }
      if (!media.leftMediaContainer && !media.rightMediaContainer) {
        this.medias.splice(this.medias.indexOf(media), 1);
      }
    }

    this.syncVideoContainers()
  }

  syncVideoContainers() {
    const mediaContainers = this.medias.reduce((containers, media) => {
      if (media.leftMediaContainer) {
        containers.push(media.leftMediaContainer);
      }
      if (media.rightMediaContainer) {
        containers.push(media.rightMediaContainer);
      }
      return containers;
    }, []);

    const mediaItems = this.meetingModeContainer.mediaItems;
    const toRemove = mediaItems.filter(item => !mediaContainers.includes(item));
    const toAdd = mediaContainers.filter(container => !mediaItems.includes(container));

    toRemove.forEach(item => this.meetingModeContainer.removeMedia(item));
    toAdd.forEach(container => this.meetingModeContainer.addMedia(container));
  }
}
